export const CLICK = 'click';
export const HOVER = 'hover';

//# sourceMappingURL=constants.js.map